import { render, staticRenderFns } from "./sales-deliveries-dashboard.vue?vue&type=template&id=85e64b6e&"
import script from "./sales-deliveries-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./sales-deliveries-dashboard.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports